import { createAction, props } from '@ngrx/store';
import { IFooter } from '../models/footer.models';

export const LOAD_SOCIAL_MEDIA_FOOTER = '[Footer] Load Social Media Footer';
export const LOAD_SOCIAL_MEDIA_FOOTER_SUCCESS = '[Footer] Load Social Media Footer SUCCESS';
export const LOAD_SOCIAL_MEDIA_FOOTER_FAIL = '[Footer] Load Social Media Footer FAILURE';

export const LOAD_FOOTER_NAVIGATION = '[Footer] Load Footer Navigation';
export const LOAD_FOOTER_NAVIGATION_SUCCESS = '[Footer] Load Footer Navigation SUCCESS';
export const LOAD_FOOTER_NAVIGATION_FAIL = '[Footer] Load Footer Navigation FAILURE';

export const loadSocialMediaFooter = createAction(
  LOAD_SOCIAL_MEDIA_FOOTER,
);

export const loadSocialMediaFooterSuccess = createAction(
  LOAD_SOCIAL_MEDIA_FOOTER_SUCCESS,
  props<{socialMediaFooter: IFooter}>(),
);

export const loadSocialMediaFooterFail = createAction(
  LOAD_SOCIAL_MEDIA_FOOTER_FAIL,
  props<{resError: string}>(),
);

export const loadFooterNavigation = createAction(
  LOAD_FOOTER_NAVIGATION,
);

export const loadFooterNavigationSuccess = createAction(
  LOAD_FOOTER_NAVIGATION_SUCCESS,
  props<{footerNavigation: IFooter}>(),
);

export const loadFooterNavigationFail = createAction(
  LOAD_FOOTER_NAVIGATION_FAIL,
  props<{resError: string}>(),
);


